<template>
  <div
    class="image"
    :class="[
      `image--${align}`,
      {
        'image--show': loaded,
        'image--logo': parseInt(width) === 10,
        'image--20': parseInt(width) === 20,
        'image--25': parseInt(width) === 25,
        'image--33': parseInt(width) === 33,
        'image--50': parseInt(width) === 50,
        'image--75': parseInt(width) === 75,
        'image--100': parseInt(width) === 100,
        'image--full-bleed': parseInt(width) < 1,
        'image--landscape': image.width > image.height,
        'image--portrait': image.height >= image.width,
        'image--highlight': includeHighlight,
        'image--caption': caption
      }
    ]">
    <img
      class="img"
      ref="image"
      :style="`max-height: ${imageStyle}`"
      :src="image.url"
      @click="highlight()" />
    <p
      class="note"
      v-html="caption"></p>
  </div>
</template>

<script>
export default {
  name: 'ImageBlock',
  props: {
    image: {
      type: Object,
      required: true
    },
    caption: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    },
    align: {
      type: String,
      default: 'left'
    },
    includeHighlight: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loaded: false,
      imageStyle: 'auto'
    }
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true
    }, 400)
  },
  methods: {
    highlight() {
      if (this.includeHighlight) {
        this.$root.$emit('galleryHighlight', [{ image: this.image, caption: this.caption }], 0)
      }
    },
    getImageHeight(image) {
      let ratio = (image.width / image.height).toFixed(2)
      let imageWidth = this.$refs.image.offsetWidth

      return `${Math.round(imageWidth / ratio)}px`
    }
  }
}
</script>

<style lang="scss" scoped>
.image {
  display: flex;
  flex-direction: column;
  opacity: 0;
  transition: opacity 200ms ease-in-out;

  &--caption {
    img {
      margin-bottom: $padding !important;
    }
  }

  &--highlight {
    img {
      cursor: pointer;
    }
  }

  .img {
    width:100%;
    height:100%;
    object-fit: contain;
    object-position: 0% 100%;
    margin:0 $padding 0 0;
    width: calc(100% - #{$padding});
    height: auto;
  }

  &--center {
    &.image--75 {
      margin-left: 12.5%;
    }

    &.image--50 {
      margin-left: 25%;
    }

    &.image--33 {
      margin-left: 33.3%;
    }

    &.image--25 {
      margin-left: 37.5%;
    }

    &.image--20 {
      margin-left: 40%;
    }
  }

  &--show {
    opacity:1;
  }

  &--50 {
    width:50%;
  }

  &--75 {
    width:75%;
  }

  &--33 {
    width:33.3%;
  }

  &--25 {
    width:25%;
  }

  &--20 {
    width:20%;
  }

  &--logo {
    width:20%;
    max-width: 140px;
  }

  &--100 {
    width:100%;
  }

  &--full-bleed {
    width: 100vw !important;
    margin: 0px;

    &.image--landscape {
      height: calc((100vw * 0.667) + #{$padding * 2});
      max-height: calc((#{$content-width} * 0.667) + #{$padding * 2.5});
    }
    &.image--portrait {
      height: calc((100vw * 1.2) + #{$padding * 2});
      max-height: calc((#{$content-width} * 1.2) + #{$padding * 2.5});
    }
    .img {
      width: 100vw !important;
      max-width: $content-width;
      height: auto;
      @media screen and (max-width: $content-width) {
        margin: -1.5rem 0 0 -1.5rem;
      }
    }


  }

  .note {
    min-height: 2.25rem;
  }

  @include mobile {
    width: 100% !important;
    height: auto !important;

    &--center {
      &.image--75 {
        margin-left: 0;
      }

      &.image--50 {
        margin-left: 0;
      }

      &.image--33 {
        margin-left: 25%;
      }

      &.image--25 {
        margin-left: 33.3%;
      }

      &.image--20 {
        margin-left: 37.5%;
      }
    }

    img {
      margin:0 0 4px 0;
      width: 100% !important;
    }

    &--33 {
      // width:50% !important;
    }

    &--25 {
      // width:33.3% !important;
    }

    &--20 {
      // width:25% !important;
    }

    &--full-bleed {
      .img {
        margin: -#{$padding} 0 0 -#{$mobile-padding};
      }
    }
  }
}
</style>
